import { render, staticRenderFns } from "./GroupGender.vue?vue&type=template&id=09bc85ab&scoped=true&"
import script from "./GroupGender.vue?vue&type=script&lang=js&"
export * from "./GroupGender.vue?vue&type=script&lang=js&"
import style0 from "./GroupGender.vue?vue&type=style&index=0&id=09bc85ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc85ab",
  null
  
)

export default component.exports